<template>
    <div class="stepper-next-prev d-flex align-items-center" :class="[buttonLayout, { 'stepper-next-prev--sticky': sticky }]">
        <button class="btn btn-outline-primary" @click="prevStep" :disabled="!enablePrevButton">{{
            currentStep === 1 ? 'Cancel' : prevButtonLabel }}</button>
        <button class="btn btn-primary" @click="nextStep" :disabled="disableNextButton">{{ nextButtonLabel }}</button>
    </div>
</template>

<script>


export default {
    props: {
        buttonLayoutPlacement: {
            type: String,
            default: 'end'
        },
        nextButtonLabel: {
            type: String,
            default: 'Next'
        },
        prevButtonLabel: {
            type: String,
            default: 'Previous'
        },
        enablePrevButton: {
            type: Boolean,
            default: true
        },
        disableNextButton: {
            type: Boolean,
            default: false
        },
        currentStep: {
            type: Number,
            required: true
        },
        totalSteps: {
            type: Number,
            required: true
        },
        sticky: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        buttonLayout() {
            if (this.buttonLayoutPlacement === 'center') {
                return 'justify-content-center'
            } else if (this.buttonLayoutPlacement === 'end') {
                return 'justify-content-end'
            } else if (this.buttonLayoutPlacement === 'between') {
                return 'justify-content-between'
            } else {
                return 'justify-content-start'
            }
        }
    },
    methods: {
        nextStep() {
            this.$emit('next');
        },
        prevStep() {
            this.$emit('prev');
        }
    }
}
</script>

<style scoped>
.stepper-next-prev {
    gap: 8px;
}

.stepper-next-prev--sticky {
    position: fixed;
    left: 5rem;
    right: 0;
    bottom: 0;
    z-index: 40;
    padding: 14px 24px calc(14px + env(safe-area-inset-bottom));
    background: #ffffff;
    border-top: 1px solid #D7D7D7;
}

.btn:disabled {
    opacity: 1;
    cursor: not-allowed;
    box-shadow: none;
}

.btn.btn-primary:disabled {
    background-color: #8C8C8C;
    border-color: #8C8C8C;
    color: #ffffff;
}

@media (max-width: 768px) {
    .stepper-next-prev--sticky {
        left: 0;
        right: 0;
        padding-left: 12px;
        padding-right: 12px;
    }
}
</style>
